/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import { Component, OnInit } from '@angular/core';
import {ShipmentHeadersService} from '../../../services/shipment-headers.service';
import {OrderHeadersService} from '../../../services/order-headers.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {permissions} from '../../../permissions';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-shipment-headers-view',
    templateUrl: './shipment-headers-view.component.html',
    styleUrls: ['./shipment-headers-view.component.scss'],
    providers: [
        OrderHeadersService,
        ShipmentHeadersService
    ]
})
export class ShipmentHeadersViewComponent implements OnInit {

    SH1_INTERNAL_ID: number = null;

    po: any = [];
    rows = [];
    cols = [];
    totalRecords = 0;
    selected = [];

    public loading = false;
    public  permissions = permissions;

    constructor(
        private shipmentHeadersService: ShipmentHeadersService,
        private orderHeadersService: OrderHeadersService,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService,
        private title: Title
    ) {
        this.title.setTitle('EDI - Shipments');
        this.cols = [
            { field: 'PO2_LINE',                 header: 'Line #',                 visible: true,  width: 8 },
            { field: 'PO2_ITEM_ID',              header: 'Item ID',                visible: true,  width: 10 },
            { field: 'PO2_SUPPLIER_PART_NUMBER', header: 'Supplier Part #',        visible: true,  width: 10 },
            { field: 'PO2_DESCRIPTION1',         header: 'Item Description',       visible: true,  width: 25 },
            { field: 'SH2_QUANTITY',             header: 'Shipped Qty',            visible: true,  width: 10 },
            { field: 'SH2_SHIPMENT_DATE',        header: 'Shipment Date',          visible: true,  width: 15 },
            { field: 'SH2_ARRIVAL_DATE',         header: 'Estimated Arrival Date', visible: true,  width: 15 }
        ];
    }

    ngOnInit() {
        this.SH1_INTERNAL_ID = this.route.snapshot.params.id;
        this.loading = true;
        this.shipmentHeadersService.getById(this.SH1_INTERNAL_ID).subscribe( res => {
            this.po = res.data;
            this.rows = res.lines;
            this.totalRecords = this.rows.length;
            this.loading = false;
        }, () => {
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('TimeOut occurred', 'Service Error', {
                timeOut: 3000,
            });
        });
    }

    onCancel() {
        window.history.back();
    }

    openPO(PO1_ID) {
        this.router.navigate(['order-headers/' + PO1_ID]);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/shipment-headers/shipment-headers-view/shipment-headers-view.component.ts